import { resource } from "./resource";

const clients = resource("/client");
const projects = resource("/project");
const api = resource("/timesheet");

// ---- Clients ----
export const getClients = async () => await clients.get();
export const createClient = async (input = {}) => await clients.post("", input);
export const updateClient = async (id, input = {}) => await clients.put(`/${id}`, input);
export const deleteClient = async (id) => await clients.del(`/${id}`);

// ---- Projects ----
export const getProjects = async () => await projects.get();
export const createProject = async (input = {}) => await projects.post("", input);
export const updateProject = async (id, input = {}) => await projects.put(`/${id}`, input);
export const deleteProject = async (id) => await projects.del(`/${id}`);

// ---- Rates ----
export const getRates = async () => await api.get("/rates");
export const createRate = async (input = {}) => await api.post("/rates", input);
export const deleteRate = async (id) => await api.del(`/rates/${id}`);

// ---- Settings + reporting ----
export const getTimesheetSettings = async () => await api.get("/settings");
export const updateTimesheetSettings = async (input = {}) => await api.put("/settings", input);
export const getProjectReport = async ({ from, to, status } = {}) =>
  await api.get("/report/project", { from, to, status });

// ---- Timesheets ----
export const createTimesheet = async (input = {}) => await api.post("", input);

/**
 * Every timesheet in the organisation. Admin only — a reporting manager gets a
 * 403 here and wants `getTeamTimesheets` instead.
 *
 * `from`/`to` are inclusive UTC calendar days and match on overlap, so asking
 * for one week also returns the sheet that straddles its edge. Without them the
 * server returns every timesheet ever recorded, with all of its activities.
 */
export const getAllTimesheets = async ({ status, from, to } = {}) =>
  await api.get("", { status, from, to });

export const getSelfTimesheets = async () => await api.get("/self");

export const getTimesheetById = async (id) => await api.get(`/${id}`);

export const updateTimesheet = async (id, input = {}) => await api.put(`/${id}`, input);

// approve / reject  { status: "approved" | "rejected", reviewNotes }
export const reviewTimesheet = async (id, input = {}) => await api.post(`/${id}/review`, input);

/** The caller's direct reports' timesheets. Same filters, no admin needed. */
export const getTeamTimesheets = async ({ status, from, to } = {}) =>
  await api.get("/team", { status, from, to });
